import { render, staticRenderFns } from "./ManagerDashboard.vue?vue&type=template&id=bccc3ed2&scoped=true&"
import script from "./ManagerDashboard.vue?vue&type=script&lang=js&"
export * from "./ManagerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDashboard.vue?vue&type=style&index=0&id=bccc3ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccc3ed2",
  null
  
)

export default component.exports